/**
 * FE-side mirror of okf-be's isFeatureDisabledOnProd helper.
 *
 * The FEATURES_DISABLED_ON_PROD array sent from BE supports two entry shapes:
 *   1. String — disabled on prod for all tenants
 *   2. Object — { featureName: string, tenantWhitelist: string[] } — disabled
 *      on prod EXCEPT for tenants in the whitelist
 *
 * This helper handles both shapes uniformly. Use it instead of
 * `disabledFeatures.includes(featureName)` whenever a feature might have a
 * tenantWhitelist entry.
 *
 * @param {string} featureName
 * @param {Object} opts
 * @param {Array}   opts.disabledFeatures - the array from platformConfigs
 * @param {boolean} opts.isProd           - typically `import.meta.env.VITE_ENV === "prod"`
 * @param {string}  [opts.tenant]         - current tenant; required when entry uses tenantWhitelist
 * @returns {boolean}
 */
export function isFeatureDisabledOnProd(featureName, { disabledFeatures, isProd, tenant }) {
  if (!isProd) return false;
  const entry = (disabledFeatures || []).find((e) =>
    typeof e === "string" ? e === featureName : e?.featureName === featureName
  );
  if (!entry) return false;
  if (typeof entry === "string") return true;
  // Object entry with tenantWhitelist
  if (Array.isArray(entry.tenantWhitelist) && tenant && entry.tenantWhitelist.includes(tenant)) {
    return false; // tenant whitelisted → feature stays enabled
  }
  return true;
}
